var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBatteryIcon = function SvgBatteryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9488_17423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 8.33334V11.6667",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 8.33334V11.6667",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 15H4.16667C3.24583 15 2.5 14.2542 2.5 13.3333V6.66667C2.5 5.74583 3.24583 5 4.16667 5H14.1667C15.0875 5 15.8333 5.74583 15.8333 6.66667V13.3333C15.8333 14.2542 15.0875 15 14.1667 15Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.834 7.5H16.679C16.8082 7.5 16.9357 7.53 17.0515 7.58833L17.4565 7.79083C17.739 7.93167 17.9173 8.22083 17.9173 8.53583V11.4642C17.9173 11.78 17.739 12.0683 17.4565 12.2092L17.0515 12.4117C16.9357 12.47 16.8082 12.5 16.679 12.5H15.834",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9488_17423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgBatteryIcon as ReactComponent };
export default __webpack_public_path__ + "battery-icon.svg";